// Phase 11 — Habits module hook.
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

interface HabitEntry { id: string; name: string; description: string; frequency: string; checked_today: boolean; created_at: string; }

export function useHabits() {
  return useQuery<HabitEntry[]>({
    queryKey: ['habits', 'entries'],
    queryFn: async () => {
      const res = await fetch('/api/modules/habits/entries', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Failed to load habits');
      return res.json();
    },
    staleTime: 30_000,
  });
}

export function useHabitCheckin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ habit_id, date }: { habit_id: string; date?: string }) => {
      const res = await fetch('/api/modules/habits/checkins', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ habit_id, date }),
      });
      if (!res.ok) throw new Error('Failed to check in');
      return res.json();
    },
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['habits'] }); },
  });
}

export function useHabitUncheck() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ habit_id, date }: { habit_id: string; date?: string }) => {
      const res = await fetch('/api/modules/habits/checkins', {
        method: 'DELETE', credentials: 'same-origin',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ habit_id, date }),
      });
      if (!res.ok) throw new Error('Failed to uncheck');
    },
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['habits'] }); },
  });
}
